import { Autocomplete, CircularProgress, TextField, Typography, useTheme } from '@mui/material'
import React from 'react'
import { ClientBriefDto } from '../../services/api/sharedTypes/Client'

interface ClientSelectProps {
    clientId: string
    onChange: (clientId: string) => void
    onChangeName?: (clientName: string) => void
    clientList?: ClientBriefDto[]
    isLoading: boolean
}

const ClientSelect: React.FC<ClientSelectProps> = ({ clientId, onChange, onChangeName, clientList, isLoading }: ClientSelectProps) => {
    const theme = useTheme();

    const selectedClient = React.useMemo(() => {
        return clientList?.find((client) => client.id === clientId) ?? null;
    }, [clientId, clientList]);

    if (isLoading) return <CircularProgress />;

    if (!clientList)
        return (
            <Typography variant="body1" color="error">
                Klienti nejsou načteni
            </Typography>
        );

    return (
        <Autocomplete
            fullWidth
            size="small"
            options={clientList}
            renderInput={(params) => (
                <TextField
                    {...params}
                    style={{ backgroundColor: theme.palette.customBackground.default }}
                    label="Klient"
                />
            )}
            getOptionLabel={(option) => option.name ?? ''}
            value={selectedClient}
            onChange={(eventChange, value) => {
                if (!value) return onChangeName && onChangeName('');
                onChange(value.id);
                onChangeName && onChangeName(value.name);
            }}
        />
    );
};

export default ClientSelect
